const initState = {
    id: null,
	rut: null,
	razonsocial: null,
	abog_patroc: null,
	rut_abog_patroc: null,
	abog_deman: null,
	rut_abog_deman: null,
    conexion: false,
    error: false,
	message:null
};

export default initState;